import { createRouter, createWebHistory } from 'vue-router'
import { handleCallback, isAuthenticated, signIn } from '../authentication'
import HomeView from '../views/HomeView.vue'
import type { DiscoveryFeature } from '@/services/discovery'
import CallbackHandler from '../components/CallbackHandler.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../components/Login.vue'),
      props: { isLogin: true }
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('../views/ProfileView.vue')
    },
    {
      path: '/auth/signinwin/main',
      name: 'signinwin-main',
      component: CallbackHandler
    },
    {
      path: '/auth/signinsilent/main',
      name: 'signinsilent-main',
      component: CallbackHandler
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('../views/RegisterView.vue')
    }
  ]
})

router.beforeEach(async (to, from) => {
  console.log(`Navigating to ${to.path} from ${from.path}`)
  // If the call is to the callback route, handle the callback
  if (to.path === '/register') {
    return true
  }
  // If the call is to the callback route, handle the callback
  if (to.path === '/auth/signinwin/main' || to.path === '/auth/signinsilent/main') {
    try {
      await handleCallback()
      return true
    } catch (error) {
      console.error('Error during beforeEach callback handling:', error)
      return false
    }
  }
  const authenticated = await isAuthenticated()
  // Make sure the user is authenticated &&❗️Avoid an infinite redirect
  if (!authenticated && to.name !== 'login') {
    // Redirect the user to the login page
    await signIn()
    return false
  }
})

export async function setDynamicRoutes(features: DiscoveryFeature[]) {
  // Map each feature to a Promise that resolves to an object containing the route data and the imported component
  const routePromises = features
    .filter((feature) => feature.componentName !== null && feature.componentName !== '')
    .map(async (feature) => {
      try {
        return {
          path: feature.defaultPath,
          name: feature.name,
          component: () => import(`../views/${feature.componentName.replace('.vue', '')}.vue`),
          props: {
            microFrontEnd: feature.tenantFeatureOverride?.url || null,
            uniqueId: feature.uniqueId
          }
        }
      } catch (error) {
        console.error('Error in setDynamicRoutes():', error)
        return null
      }
    })

  // Wait for all Promises to resolve and add each route to the router
  return (await Promise.all(routePromises)).filter((route) => route !== null)
}

export default router
